import './App.css';
import UseEffectAPI from './components/useEffect';


function App() {
  return (
    <div className="App">
      <UseEffectAPI />
    </div>
  );
}

export default App;
